<!--
 * @Author: Shber
 * @Date: 2022-03-08 16:49:02
 * @LastEditors: Shber
 * @LastEditTime: 2023-06-14 17:55:53
 * @Description:
-->
<template>
  <div class="auth_content">
    <component
      :is="componentId"
      :status-show="true"
      :readonly="isReadonly"
      :data-info="authInfo"
      :parent-data="pathInfo"
      :auth-info="authStatus"
    />
  </div>
</template>
<script>
import { Toast } from 'vant'
import { ajaxHttp } from '@/api/api'
import authAi from '../nameAuth/aiAuth/form'
import authNormal from '../nameAuth/normalAuth/form'
import authDuty from '../dutyAuth/form'
import authBrand from '../brandAuth/index'

export default {
  name: 'AuthStatus',
  components: {
    authAi, // 扫脸认证
    authNormal, // 实名认证
    authDuty, // 职业认证
    authBrand // 企业认证
  },
  props: {},
  data() {
    return {
      isReadonly: true,
      componentId: '',
      pathInfo: {},
      authInfo: {},
      authStatus: {}
    }
  },

  // created() {
  //   const self = this
  //   this.$nextTick(() => {
  //     const { query } = self.$route
  //     self.pathInfo = query
  //     self.getAuthStatus(query.type)
  //   })
  // },
  beforeMount() {
    const self = this
    this.$nextTick(() => {
      const { query } = self.$route
      self.pathInfo = query
      switch (query.type + '') { // Number 转 String
        case '1':
          this.componentId = 'authAi' // 实名ai人脸认证
          break
        case '3':
          this.componentId = 'authDuty' // 职业认证
          break
        case '4': // true 为只读
          this.componentId = 'authBrand' // 企业认证
          break
        default:
          this.componentId = 'authNormal' // 实名表单认证
          break
      }
      // setTimeout(() => {
      self.getAuthStatus(query.type)
      // }, 600)
    })
  },
  methods: {
    getAuthStatus($type) {
      ajaxHttp.$get('/h5/auth_status').then(res => {
        if (res.code === 1) {
          this.authStatus = res.data
          switch ($type + '') { // Number 转 String
            case '1':
              this.isReadonly = res.data.is_realname_auth !== '3'
              break
            case '3':
              this.isReadonly = res.data.isauth !== '3'
              break
            case '4': // true 为只读
              this.isReadonly = true
              break
            default:
              this.isReadonly = res.data.is_realname_auth !== '3'
              break
          }
        } else { Toast(res.message) }
      })
    },
    goPath($url, $parame = {}) {
      this.$router.push({ path: $url, query: $parame })
    }
  }
}
</script>
